import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import { Components, Utils } from 'versafleet-core';
import ReduxActions from 'reduxActions';
import classNames from 'classnames';

class CustomInfoEdit extends React.Component {
  UNSAFE_componentWillMount() {
    this.props.dispatch(ReduxActions.task.fetchTaskSystemTags());
  }

  _renderCustomInfoInput(item, i, error) {
    const { input } = this.props.strings;
    const {
      data, form, customFieldGroup, tags,
    } = this.props;
    const customField = form.custom_fields_attributes[i] || {};
    const id = Utils.Helper.isNullOrUndefined(this.props.id) ? undefined
      : `${this.props.id}__${item.field_type}-input`;
    const subtitleClass = 'vf-task__edit-form__custom-info__numeric-dropdown__subtitle';
    let selectedOption;

    switch (item.field_type) {
      case 'text':
      case 'number':
        return (
          <Components.Input.Textbox
            error={error}
            id={id}
            onChange={value => this.props.onFormChange('custom_fields_attributes', { ...customField, value }, i)}
            placeholder={input[`${item.field_type}Hint`]}
            value={customField.value}
          />
        );
      case 'date':
        return (
          <Components.Input.DatePicker
            error={error}
            id={id}
            onChange={value => this.props.onFormChange('custom_fields_attributes', { ...customField, value }, i)}
            placeholder={input[`${item.field_type}Hint`]}
            value={customField.value}
          />
        );
      case 'time':
        return (
          <Components.Input.TimePicker
            error={error}
            id={id}
            onChange={value => this.props.onFormChange('custom_fields_attributes', { ...customField, value }, i)}
            placeholder={input[`${item.field_type}Hint`]}
            value={customField.value}
          />
        );
      case 'choice':
        return (
          <Components.Input.Radio
            error={error}
            onChange={value => this.props.onFormChange('custom_fields_attributes',
              { ...customField, value }, i)}
            value={customField.value}
          >
            {item.options.map(option => (
              <Components.Input.Radio.Item
                id={id}
                name={item.name}
                value={option.value}
              >
                {option.value}
              </Components.Input.Radio.Item>
            ))}
          </Components.Input.Radio>
        );
      case 'search_list':
        selectedOption = item.options
          .find(option => option.value === this.props.form.custom_fields_attributes[i].value);

        return (
          <div>
            <Components.Input.Select
              error={error}
              id={id}
              onChange={value => this.props.onFormChange('custom_fields_attributes', { ...customField, subvalue: null, value }, i)}
              options={item.options.map(option => ({
                text: option.value,
                value: option.value,
              }))}
              placeholder={input.optionHint}
              value={customField.value}
            />
            {
              Utils.Helper.isNullOrUndefined(selectedOption)
                ? null
                : (
                  <div className="vf-task__edit-form__custom-info__search-list__sub-field-name">
                    {item.subname}
                    <div className="vf-task__edit-form__custom-info__search-list__suboption">
                      {
                        Utils.Helper.isNullOrUndefined(selectedOption.suboptions)
                          ? input.emptySuboptionHint
                          : (
                            <Components.Input.Select
                              onChange={value => this.props.onFormChange('custom_fields_attributes', { ...customField, subvalue: value }, i)}
                              options={selectedOption.suboptions.map(suboption => ({
                                text: suboption,
                                value: suboption,
                              }))}
                              placeholder={input.suboptionHint}
                              value={customField.subvalue}
                            />
                          )
                      }
                    </div>
                  </div>
                )
            }
          </div>
        );
      case 'dropdown':
        return (
          <Components.Input.UntypableSelect
            error={error}
            hasEmptyOption
            id={id}
            onChange={value => this.props.onFormChange('custom_fields_attributes', { ...customField, value }, i)}
            options={
              item.options.map(option => ({ value: option.value, text: option.value }))
            }
            value={customField.value}
          />
        );
      case 'numeric_dropdown':
        return (
          <Components.Input.UntypableSelect
            error={error}
            hasEmptyOption
            id={id}
            onChange={(subvalue) => {
              const options = item.options.filter(option => option.text === subvalue);
              this.props.onFormChange('custom_fields_attributes', {
                ...customField,
                value: options[0] && options[0].value,
                subvalue,
              }, i);
            }}
            options={
              item.options.map(option => ({
                value: option.text,
                text: (
                  <div>
                    {option.text}
                    <div className={subtitleClass}>{option.value}</div>
                  </div>
                ),
              }))
            }
            value={customField.subvalue}
          />
        );
      case 'rubric':
        return (
          <Components.Form.Block fontWeight="REGULAR" level={0}>
            {Utils.RubricCustomFieldParser.parseRubric(
              item, data, Utils.TaskMergeTags, tags, form, customFieldGroup,
            )}
          </Components.Form.Block>
        );
      case 'checkbox':
        return this._renderCheckboxes(item, i, id, error);
      default:
        return false;
    }
  }

  _renderCheckboxes(item, i, id, error) {
    const { form, onFormChange } = this.props;
    const customField = form.custom_fields_attributes[i] || {};
    let parsedValue = Utils.Helper.isNullOrUndefined(customField.value)
      ? [] : JSON.parse(form.custom_fields_attributes[i].value);
    return (
      item.options.map((option, j) => (
        <Components.Input.Checkbox
          error={error}
          id={id}
          // eslint-disable-next-line react/no-array-index-key
          key={`${id}__${j}`}
          onChange={(value) => {
            parsedValue = value ? [...parsedValue, option.value]
              : parsedValue.filter(v => v !== option.value);
            parsedValue = parsedValue.length === 0 ? undefined : JSON.stringify(parsedValue);
            onFormChange('custom_fields_attributes', { ...customField, value: parsedValue }, i);
          }}
          value={parsedValue.filter(v => v === option.value).length > 0}
        >
          {option.value}
        </Components.Input.Checkbox>
      ))
    );
  }

  _renderCustomFields(customFieldGroup, error) {
    const newCreatedErrors = error.filter(e => Utils.Helper.isNullOrUndefined(e.id));
    let index = 0;

    return (
      customFieldGroup.custom_field_descriptions.map((item, i) => {
        const customField = this.props.form.custom_fields_attributes[i];
        let customInfoError;

        if (Utils.Helper.isNullOrUndefined(customField)
          || Utils.Helper.isNullOrUndefined(customField.id)
          || Number.isNaN(customField.id)) {
          customInfoError = newCreatedErrors[index];
          index += 1;
        } else {
          customInfoError = error.find(e => e.id === customField.id);
        }

        return (
          // eslint-disable-next-line react/no-array-index-key
          <div key={i}>
            <Components.Form.Block fontColor="GREY" fontWeight="REGULAR" level={1}>
              {item.name}
            </Components.Form.Block>
            <Components.Form.Block fontColor="TEXT" fontWeight="REGULAR" isRequired={item.is_mandatory} level={2}>
              {
                this._renderCustomInfoInput(item, i,
                  Utils.Helper.isNullOrUndefined(customInfoError) ? [] : customInfoError.value)
              }
            </Components.Form.Block>
            <Components.Form.Divider size="SMALL" />
          </div>
        );
      })
    );
  }

  render() {
    const {
      customFieldGroup, data, error, strings, form,
    } = this.props;
    let id;
    if (this.props.isNewTask) {
      id = this.props.form.custom_field_group_id;
    } else if (!Utils.Helper.isNullOrUndefined(data.custom_field_group)) {
      id = data.custom_field_group.id;
    } else {
      id = null;
    }

    const inputClassNames = classNames({
      'vf-task__edit-form__custom-info__parent__input-select': true,
      'vf-task__edit-form__custom-info__parent__input-select--desktop':
        !Utils.UserAgentDetector.isMobileOrTablet(),
      'vf-task__edit-form__custom-info__parent__input-select--mobile':
        Utils.UserAgentDetector.isMobileOrTablet(),
    });

    return (
      <Components.Form.ExpandableContainer
        id={this.props.id}
        parent={(
          <Components.Form.Block
            contentClassName="vf-task__edit-form__custom-info__parent"
            level={0}
          >
            <div className="vf-task__edit-form__custom-info__parent__title">{strings.title}</div>
            {
              !this.props.isNewTask && Utils.Helper.isNullOrUndefined(id) ? false
                : <i className="versa-customfields" />
            }
            {
              !this.props.isNewTask && Utils.Helper.isNullOrUndefined(id) ? false
                : (
                  <Components.Input.UntypableSelect
                    className={inputClassNames}
                    disabled={!this.props.isNewTask}
                    id={Utils.Helper.isNullOrUndefined(this.props.id) ? undefined
                      : `${this.props.id}__select-group-input`}
                    onChange={(value) => {
                      if (value !== id) {
                        this.props.onFormChange('custom_field_group_id', value);
                      }
                    }}
                    options={this.props.options}
                    value={id}
                  />
                )
            }
          </Components.Form.Block>
        )}
        showByDefault
      >
        {
          !Utils.Helper.isNullOrUndefined(customFieldGroup) && !customFieldGroup.archived
          && (form.custom_fields_attributes || []).length !== 0
            ? this._renderCustomFields(customFieldGroup, error) : false
        }
      </Components.Form.ExpandableContainer>
    );
  }
}

CustomInfoEdit.displayName = 'Custom Info Edit';

CustomInfoEdit.propTypes = {
  customFieldGroup: PropTypes.shape(),
  data: PropTypes.shape(),
  dispatch: PropTypes.func.isRequired,
  error: PropTypes.arrayOf(PropTypes.shape()),
  form: PropTypes.shape(),
  id: PropTypes.string,
  isNewTask: PropTypes.bool,
  onFormChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape()),
  strings: PropTypes.shape(),
  tags: PropTypes.shape(),
};

CustomInfoEdit.defaultProps = {
  customFieldGroup: {},
  data: {},
  error: [],
  form: {},
  id: null,
  isNewTask: false,
  onFormChange: () => {},
  options: [],
  strings: {},
  tags: {},
};

function mapStateToProps(state) {
  const { task } = state;
  return {
    tags: task.systemTags,
  };
}

export default connect(mapStateToProps)(CustomInfoEdit);
